import React, { useCallback, useMemo, useRef, useState } from "react";
import imageExtensions from "image-extensions";
import galleryIcon from "../../../assets/icons/gallery.svg";
import trashIcon from "../../../assets/icons/trash.svg";
import idGenerator from "../../../utils/idGenerator";
import { ImageContainer } from "./styles";

const ImageSelectRender = ({
                               accept = "image/png, image/jpeg, image/jpg, image/jpg",
                               defaultValue,
                               onAdd,
                               onRemove,
                               onLoad,
                           }) => {
    const inputRef = useRef(null);
    const [file, setFile] = useState(null);

    const inputName = useMemo(() => idGenerator(), []);

    const handleFileChange = useCallback(
        async (event) => {
            if (!inputRef.current) return;

            if (!event.target.files) {
                inputRef.current.value = "";
                return;
            }

            const file = event.target.files[0];

            if (!file) {
                inputRef.current.value = "";
                return;
            }

            const { name } = file;
            const extension = name.split(".").at(-1);

            const isImageFile = imageExtensions.some((ext) => ext === extension);

            if (!isImageFile) {
                console.log("This file is not an image.");
                inputRef.current.value = "";
                return;
            }

            setFile(file);
            if (onAdd) onAdd(event);
        },
        [onAdd]
    );

    const selectedImage = useMemo(() => {
        if (!file) return "";
        return URL.createObjectURL(file);
    }, [file]);

    const handleImageLoad = useCallback(() => {
        if (onLoad) onLoad();
    }, [onLoad]);

    if (onAdd) {
        return (
            <ImageContainer>
                <img style={{ height: 48, width: 48 }} src={galleryIcon} alt="Add" />
                <input
                    type="file"
                    accept={accept}
                    name={inputName}
                    onChange={handleFileChange}
                    ref={inputRef}
                />
            </ImageContainer>
        );
    }

    return (
        <ImageContainer>
            <img
                src={defaultValue}
                alt="Selected file"
                className="image__selected-image"
                onLoad={handleImageLoad}
            />

            <button type="button" onClick={onRemove}>
                <img src={trashIcon} alt="Remove" />
            </button>
        </ImageContainer>
    );
};

export default ImageSelectRender;
